import { Helmet } from "react-helmet-async";
import { SITE } from "@/config";

export default function SEO() {
    const canonical = `${SITE.canonicalBase}/`;
    const ogImage = `${SITE.canonicalBase}${SITE.ogImage}`;

    const personSchema = {
        "@context": "https://schema.org",
        "@type": "Person",
        name: SITE.name,
        alternateName: SITE.handle,
        jobTitle: "AI Visual Creator, AI Filmmaker & Video Editor",
        telephone: SITE.phone,
        email: SITE.email,
        url: canonical,
        image: ogImage,
        sameAs: [SITE.instagram, SITE.linkedin],
        address: {
            "@type": "PostalAddress",
            addressLocality: SITE.locality,
            addressRegion: SITE.region,
            addressCountry: SITE.country,
        },
        knowsAbout: [
            "AI Visual Creation",
            "AI Filmmaking",
            "Cinematic AI Films",
            "AI Brand Films",
            "Video Editing",
            "AI UGC Ads",
            "Short-form Content",
        ],
        areaServed: ["Delhi", "India"],
    };

    const websiteSchema = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE.title,
        url: canonical,
        author: { "@type": "Person", name: SITE.name },
    };

    return (
        <Helmet>
            <html lang="en" />
            <title>{SITE.title}</title>
            <meta name="description" content={SITE.description} />
            <meta name="author" content={SITE.name} />
            <link rel="canonical" href={canonical} />
            <meta name="robots" content="index, follow" />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="createwithnikhil" />
            <meta property="og:title" content={SITE.title} />
            <meta property="og:description" content={SITE.description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={SITE.title} />
            <meta name="twitter:description" content={SITE.description} />
            <meta name="twitter:image" content={ogImage} />

            <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
            <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
        </Helmet>
    );
}
